import { Component } from '@angular/core';
import { AppToolbar } from '../../components/app-toolbar/app-toolbar';

@Component({
  selector: 'app-about-page',
  imports: [AppToolbar],
  templateUrl: './about-page.html',
  styleUrl: './about-page.scss',
})
export class AboutPage {}
